import React from 'react';
import {connect} from 'react-redux';
import Modal from 'react-responsive-modal';
import 'react-responsive-modal/lib/react-responsive-modal.css';
import { SLoader } from '@avalara/skylab-sdk/react';

import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import ClosedReturnsFilingPreview from './ClosedReturnsFilingPreview';

import { LOG_LEVELS } from "../../utils/logger";
import Logger from "../../utils/logger";

const log = new Logger('CLOSED_RETURNS_PREVIEW_MODAL', LOG_LEVELS.DEBUG);

const MODAL_CLASSNAMES =  {
    modal: 'modal-full-width-height'
};

class ClosedReturnsPreviewModal extends React.Component {
  render() {
    log.debug('render(): ClosedReturnPreviewModal: props: ', this.props);

    return (
      <span>
        <Modal
          classNames={MODAL_CLASSNAMES}
          open={this.props.showModal}
          onClose={this.props.onCloseModal}
          closeOnEsc={true}
          blockScroll={true}
          closeOnOverlayClick={true}
          center
        >
          <h2><LanguageStringResolver string='closeReturns_ViewReturn_Title'/></h2>
          {this.props.isLoading ? (
            <div className="mb30" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh' }} data-testid="closed-return-preview-loading">
              <SLoader loading className="small" />
            </div>
          ) : (this.props.data.data) ? (
            <ClosedReturnsFilingPreview
              documentData={this.props.data.data || undefined}
              documentType={this.props.data.contentType || undefined}
              fileName={this.props.data.fileName}
            /> ) : (<div><LanguageStringResolver string='inAppMessage_App_Error_69'/></div>)}
        </Modal>
      </span>
    );
  };
}


ClosedReturnsPreviewModal.defaultProps = {
  showModal: false,
  onCloseModal: () => {},
  data: {},
  isLoading: false
};

function mapStateToProps(state) {
    return {};
}

export default connect(mapStateToProps)(ClosedReturnsPreviewModal);